import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import '@/utils/rem.js'
import '@/assets/style/common.css'
import '@/assets/style/mobile.css'
import i18n from './i18n'

Vue.use(ElementUI)
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')